<template>
  <v-dialog :value="dialog" width="50%" persistent>
    <v-card>
      <v-card-title class="title">
        {{ this.title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="body-1">
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onConfirm" color="red" outline>
          {{yesBtnText}}
        </v-btn>
        <v-btn @click="onCancel" color="grey" outline>
          {{noBtnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/i18n'
export default {
  name: "Confirmation",
  props: {
      dialog: Boolean,
      title: String,
      yesBtnText:{
          type:String,
          default:i18n.t('rms.buttons.yes')
      },
      noBtnText:{
          type:String,
          default:i18n.t('rms.buttons.no')
      }
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style></style>
